module.exports = __webpack_public_path__ + "static/human-brain-31b126339b419caed70a4879f0903759.svg";